import { render, staticRenderFns } from "./HistoricalEnquiry.vue?vue&type=template&id=44df903d"
import script from "./HistoricalEnquiry.vue?vue&type=script&lang=js"
export * from "./HistoricalEnquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports